export default "__VITE_ASSET__e9df9037__"